import styled from "styled-components";
import { KitForm, KitButton } from "@chargepoint/cp-toolkit";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  align-self: center;

  @media (max-width: 768px) {
    padding: 15px;
    padding-bottom: 100px;
  }
`;

export const MiddleContainer = styled.div`
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px 10px;
  flex-direction: column;
  margin-bottom: 20px;
  max-width: 440px;
  width: 100%;
`;

export const Title = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #4c4c4c;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #4c4c4c;
`;

export const CenteredButton = styled(KitButton)`
  margin: 50px 0px;
  align-self: center;
  background-color: #a2a11a;

  &.gYQL.link:focus {
    outline: 0px;
  }
`;

export const EnterContactView = styled.div`
  display: flex;
  flex-direction: row;
  align-item: flex-start;
  justify-content: flex-start;
  width: 100%;
  max-width: 440px;
  gap: 10px;
  margin-top: 25px;
`;

export const ContactGroup = styled(KitForm.Group)`
  width: 30%;
`;

export const InputGroup = styled(KitForm.Group)`
  margin-top: 37px;
  width: 100%;
  align-self: flex-end;
`;

export const Input = styled(KitForm.Input)`
  width: 100%;
`;
